import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  articles: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_POPULAR_LIST:
      return Object.assign({}, state, {
        isLoading: true,
        error: false,
        articles: [],
      });
    case types.RECEIVE_POPULAR_LIST:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        articles: action.payload.articles,
      });
    case types.RECEIVE_POPULAR_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        articles: [],
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./home/reducers/reducer-popular-list.js